import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './NavBar.css';
import logo from '../../Assets/Images/logo.png';
import { ShoppingCartIcon, UserIcon } from '../Common/Icons';
import { useCart } from '../Contexts/CartContext';
import { useTheme } from '../Contexts/ThemeContext';

const NavBar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);

  const { cartItemCount, setIsCartOpen } = useCart();
  const { isDarkMode, toggleTheme } = useTheme();

  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleServicesDropdown = () => {
    setIsServicesDropdownOpen(!isServicesDropdownOpen);
    setIsUserDropdownOpen(false);
  };

  const toggleUserDropdown = () => {
    setIsUserDropdownOpen(!isUserDropdownOpen);
    setIsServicesDropdownOpen(false);
  };

  const handleServicesLinkClick = (e) => {
    if (window.innerWidth > 900) {
      handleLinkClick();
    }
  };

  return (
    <nav className={`navbar ${isDarkMode ? 'dark' : ''}`}>
      <div className="navbar-logo">
        <Link to="/" onClick={handleLinkClick}>
          <img src={logo} alt="Cowdog Technologies Logo" />
        </Link>
      </div>

      <div className="navbar-company-name">
        <Link to="/" onClick={handleLinkClick}>Cowdog Technologies</Link>
      </div>

      <button
        className="mobile-menu-toggle"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        aria-label="Toggle navigation menu"
      >
        &#9776;
      </button>

      <div className={`navbar-links-and-icons ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
        <ul className="navbar-links">
          {/* Desktop dropdown */}
          <li
            className="nav-item desktop-only"
            onMouseEnter={() => setIsServicesDropdownOpen(true)}
            onMouseLeave={() => setIsServicesDropdownOpen(false)}
          >
            <Link to="/services" className="dropdown-toggle" onClick={handleServicesLinkClick}>
              Services <span className={`dropdown-indicator ${isServicesDropdownOpen ? 'open' : ''}`}>▼</span>
            </Link>
            <ul className={`dropdown-menu ${isServicesDropdownOpen ? 'dropdown-open' : ''}`}>
              <li><Link to="/services/repair" onClick={handleLinkClick}>Game Console & Computer Repair</Link></li>
              <li><Link to="/services/modifications" onClick={handleLinkClick}>Console & Computer Modifications</Link></li>
              <li><Link to="/services/custom" onClick={handleLinkClick}>Custom & Unique Projects</Link></li>
            </ul>
          </li>

          {/* Mobile simple link */}
          <li className="mobile-only"><Link to="/services" onClick={handleLinkClick}>Services</Link></li>
          <li><Link to="/about" onClick={handleLinkClick}>About Us</Link></li>
          <li><Link to="/shop" onClick={handleLinkClick}>Shop</Link></li>
          <li><Link to="/contact" onClick={handleLinkClick}>Contact</Link></li>
        </ul>

        <div className="navbar-bottom">
          {/* Mobile-only dark mode toggle */}
          <div className="dark-mode-toggle mobile-only">
            <span>Dark Mode</span>
            <label className="switch">
              <input type="checkbox" checked={isDarkMode} onChange={toggleTheme} />
              <span className="slider round"></span>
            </label>
          </div>

          <div className="navbar-right">
            {/* Desktop dropdown */}
            <div
              className="user-dropdown desktop-only"
              onMouseEnter={() => setIsUserDropdownOpen(true)}
              onMouseLeave={() => setIsUserDropdownOpen(false)}
            >
              <button className="user-button dropdown-toggle" onClick={toggleUserDropdown}>
                <UserIcon className="vintage-icon" />
              </button>
              <ul className={`user-menu ${isUserDropdownOpen ? 'dropdown-open' : ''}`}>
                <li><Link to="/signin" onClick={handleLinkClick}>Sign In / Register</Link></li>
              </ul>
            </div>

            {/* Mobile simple icon link */}
            <Link to="/signin" className="user-button mobile-only" onClick={handleLinkClick}>
              <UserIcon className="vintage-icon" />
            </Link>

            <div className="shopping-cart">
              <button className="cart-button" onClick={() => { setIsCartOpen(true); handleLinkClick(); }}>
                <ShoppingCartIcon className="vintage-icon" />
                {cartItemCount > 0 && (
                  <span className="cart-badge">{cartItemCount}</span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
